"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const StyledPath = _styledComponents.default.path.withConfig({
  displayName: "IconAppMenu__StyledPath",
  componentId: "sc-1sk1vh0-0"
})(["", ""], ({
  gFill,
  theme
}) => `fill: ${typeof gFill === 'function' ? gFill(theme) : gFill}`);
const IconAppMenu = ({
  fill,
  width,
  height
}) => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: width,
  height: height,
  version: "1.1",
  viewBox: "0 0 36 36"
}, /*#__PURE__*/_react.default.createElement(StyledPath, {
  d: "M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0zm-3.75 18.625h-3.125l-.177.005A3.129 3.129 0 0 0 8 21.75v3.125l.005.177A3.129 3.129 0 0 0 11.125 28h3.125l.177-.005a3.129 3.129 0 0 0 2.948-3.12V21.75l-.005-.177a3.129 3.129 0 0 0-3.12-2.948zm10.625 0H21.75l-.177.005a3.129 3.129 0 0 0-2.948 3.12v3.125l.005.177A3.129 3.129 0 0 0 21.75 28h3.125l.177-.005A3.129 3.129 0 0 0 28 24.875V21.75l-.005-.177a3.129 3.129 0 0 0-3.12-2.948zM14.25 8h-3.125l-.177.005A3.13 3.13 0 0 0 8 11.125v3.125l.005.177a3.13 3.13 0 0 0 3.12 2.948h3.125l.177-.005a3.13 3.13 0 0 0 2.948-3.12v-3.125l-.005-.177A3.13 3.13 0 0 0 14.25 8zm10.625 0H21.75l-.177.005a3.13 3.13 0 0 0-2.948 3.12v3.125l.005.177a3.129 3.129 0 0 0 3.12 2.948h3.125l.177-.005A3.129 3.129 0 0 0 28 14.25v-3.125l-.005-.177A3.13 3.13 0 0 0 24.875 8z",
  gFill: fill,
  fillRule: "evenodd"
}));
IconAppMenu.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  fill: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
};
IconAppMenu.defaultProps = {
  width: '34',
  height: '34',
  fill: 'white'
};
const _default = IconAppMenu;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledPath, "StyledPath", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/IconAppMenu.js");
  reactHotLoader.register(IconAppMenu, "IconAppMenu", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/IconAppMenu.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/IconAppMenu.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();